export enum AboutUsEnum {
  ABOUT_US_YOUTUBE_EMBED = 'about-us--youtube-embed',
  ABOUT_US_SCHEDULE_NOW_BUTTON = 'about-us--schedule-now-button',
}
